import { apiRequestBase } from "./client";
import { env } from "../config/env";

const post = <T>(path: string, body: unknown) =>
  apiRequestBase<T>(env.salesInvoiceBaseUrl, path, { method: "POST", body });

const get = <T>(path: string) =>
  apiRequestBase<T>(env.salesInvoiceBaseUrl, path, { method: "GET" });

export const salesInvoiceApi = {
  getReturnablePosInvoices: (payload: unknown) =>
    post("/Invoice/GetReturnablePosInvoices", payload),
  getCreditMemos: (payload: unknown) =>
    post("/Invoice/getall", payload),
  getInvoiceById: (id: number) =>
    get(`/Invoice/Details?id=${id}`),
  getInvoiceSettings: () =>
    get<{ binNumber?: string | null; taxRegistrationNumber?: string | null }>("/Invoice/GetInvoiceSettings"),
};
